import React from 'react';
import { Link } from 'react-router-dom';

// The row's own action must not also select the row (open the drawer), and
// Enter on it must not reach the table's listbox key handler.
const stop = (e) => e.stopPropagation();

/**
 * Per-row "Offboard apps" entry on the Leavers tab. Every leaver gets it,
 * admins included: the server lets connected_apps.view holders open a
 * leaving admin's profile, so IT Admin can offboard them too.
 */
export default function LeaverRowAction({ user }) {
  return (
    <Link
      className="btn btn-secondary btn-small ut-row-offboard"
      to={`/profile/${user.id}?tab=connected-apps`}
      onClick={stop}
      onKeyDown={stop}
    >
      Offboard apps
    </Link>
  );
}
